import { useTranslation } from 'react-i18next';

import { FamilleCardReprendreSouscription } from '@/components/Dico';
import Image from '@/components/Image/Image';
import { TrendingValue } from '@/components/TrendingValue/TrendingValue';

import styles from './styles.module.css';

type Props = {
  nomContrat: string;
  famille: keyof typeof FamilleCardReprendreSouscription;
  logoAssuranceWebp?: string;
  logoAssuranceDefault: string;
  montant?: number;
  performance: number;
  plusMoinsValue: number;
  interets: number;
  isInterets: boolean;
};

const CardInformation = ({
  nomContrat,
  famille,
  logoAssuranceWebp,
  logoAssuranceDefault,
  montant,
  performance,
  plusMoinsValue,
  interets,
  isInterets,
}: Props) => {
  const { t } = useTranslation();
  const controlPlusLessInterest = interets >= 0 ? 'textStatsPositifNewCard' : 'textStatsNegatifNewCard';
  const controlNumberInteret =
    interets >= 0
      ? '+' + t('format.currencyFlexible', { value: interets })
      : t('format.currencyFlexible', { value: interets });

  return (
    <div className={styles.boxCardInformation}>
      {FamilleCardReprendreSouscription[famille as keyof typeof FamilleCardReprendreSouscription]}
      <div className={styles.contentNameLogo}>
        <div>
          <Image defaultSrc={logoAssuranceDefault} webpSrc={logoAssuranceWebp} width={70} alt="Logo assureur" />
        </div>
        <div>
          <p className={styles.nameProduct}>{nomContrat}</p>
        </div>
      </div>
      <div className={styles.contentValueCard}>
        <span className={`${styles.valueProduct} `}>{t('format.currencyFlexible', { value: montant })}</span>
        <TrendingValue value={plusMoinsValue} secondaryValue={performance} icon={plusMoinsValue !== null} />
        {isInterets && (
          <p>
            Intérêts à venir: <span className={controlPlusLessInterest}>{controlNumberInteret}</span>{' '}
          </p>
        )}
      </div>
    </div>
  );
};

export default CardInformation;
